import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useState } from 'react';
import { Button, Divider, Form, Modal, Select } from 'semantic-ui-react';
import { useStore } from '../../stores/store';
import {
  ApproveOptions,
  ApproveOptions1,
  DenyOptions,
  moveOptions,
  VerifyOptions,
} from '../options/otherOptions/approveOptions';
import { Activity } from './../../models/activity';
import agent from '../../api/agent';
import { toast } from 'react-toastify';

function ApproveModalOutward() {
  const {
    dashboardStore: { dashboard, DenialModalOpen },
    activityStore,
    userStore,
    commonStore,
  } = useStore();
  const { selectedActivity } = activityStore;
  const [, setOpen] = useState(false);
  const [comments, setComments] = useState('');
  const [commentDropValue, setCommentDropValue] = useState('');

  const handleChange = (e: SyntheticEvent, data: any) => {
    setComments(data.value);
    setCommentDropValue('');
  };

  const outwardUnvaultHandler = async (payload: any) => {
    try {
      let result = await agent.Outwards.outwardUnvaultUpdate(payload);
      if (result?.data?.includes('successfully')) {
        commonStore.updateHistoryAlonePOST(
          `Unvaulted the asset ${selectedActivity?.title} successfully`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Outward Asset Unvault Completed',
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          result.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
      dashboard.valueForL3Orders = 'VerifyOutward';
    } catch {
      toast.error('Something went wrong');
    }
  };
  const verifyHandler = async (payload: any) => {
    try {
      let result = await agent.Outwards.outwardVerifyUpdate(payload);
      if (result?.data?.includes('denied')) {
        commonStore.updateHistoryAlonePOST(
          `The asset ${selectedActivity?.title} is denied due to reason: ${
            commentDropValue ? commentDropValue : comments
          }`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Outward Asset verification denied',
        );
        dashboard.valueForL3Orders = 'Unvault';
      } else if (result?.data?.includes('verified')) {
        commonStore.updateHistoryAlonePOST(
          `The asset ${selectedActivity?.title} is successfully verified`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Outward Asset Verified',
        );
        dashboard.valueForL3Orders = 'ApproveOutward';
      } else {
        commonStore.updateHistoryAlonePOST(
          result?.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
    } catch {
      toast.error('Something went wrong');
    }
  };
  const approveHandler = async (payload: any) => {
    try {
      let result = await agent.Outwards.outwardApproveUpdate(payload);
      if (result?.data?.includes('denied')) {
        commonStore.updateHistoryAlonePOST(
          `The asset ${selectedActivity?.title} is denied due to reason: ${
            commentDropValue ? commentDropValue : comments
          }`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Outward Asset approval denied',
        );
      } else if (result?.data?.includes('approved')) {
        commonStore.updateHistoryAlonePOST(
          `The asset ${selectedActivity?.title} is approved for assigning the picker `,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Outward Asset Approved',
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          result?.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
      dashboard.valueForL3Orders = 'AssignPickerOutward';
    } catch {
      toast.error('Something went wrong');
    }
  };
  const moveHandler = async (payload: any) => {
    try {
      let result = await agent.Outwards.outwardMoveUpdate(payload);
      if (result?.data?.includes('successfully')) {
        commonStore.updateHistoryAlonePOST(
          `The Asset ${selectedActivity?.title} is successfully moved by ${userStore.user?.displayName}`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Moved For Packing',
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          result?.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
      dashboard.valueForL3Orders = 'Package';
    } catch {
      toast.error('Something went wrong');
    }
  };
  const packHandler = async (payload: any) => {
    try {
      let result = await agent.Outwards.outwardPackUpdate(payload);
      if (result?.data?.includes('successfully')) {
        commonStore.updateHistoryAlonePOST(
          `The asset ${selectedActivity?.title} is packed and sent for billing`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
        await agent.InventoryDelivery.OrderTrackingStatus(
          activityStore.selectedActivity?.id,
          'Outward Asset Packed',
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          result?.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
      dashboard.valueForL3Orders = 'Billing';
    } catch {
      toast.error('Something went wrong');
    }
  };

  const saveFunction = async () => {
    if (selectedActivity !== undefined) {
      // global values
      const Activity: Activity = { ...selectedActivity };
      const boolVal = dashboard.ApproveDenialHeader === 'Deny' ? false : true;

      let payload: any = {};
      const filter = (data: any) => {
        data?.forEach((localData: any) => {
          if (localData.id === Activity?.id) {
            payload = {
              id: localData.deliveryRequestId || '',
              comment: comments || commentDropValue,
            };
          }
        });
      };

      if (dashboard.valueForL3Orders === 'Unvault') {
        filter(activityStore.outward.unvault?.data);
        outwardUnvaultHandler(payload);
      } else if (dashboard.valueForL3Orders === 'VerifyOutward') {
        filter(activityStore.outward.verifyOutward?.data);
        payload = {
          ...payload,
          verify: boolVal,
        };
        verifyHandler(payload);
      } else if (dashboard.valueForL3Orders === 'ApproveOutward') {
        filter(activityStore.outward.approveOutward?.data);
        payload = {
          ...payload,
          approve: boolVal,
        };
        approveHandler(payload);
      } else if (dashboard.valueForL3Orders === 'Move') {
        filter(activityStore.outward.move?.data);

        moveHandler(payload);
      } else if (dashboard.valueForL3Orders === 'Package') {
        filter(activityStore.outward.package?.data);

        packHandler(payload);
      }
      DenialModalOpen(false, '', false, '');
    }
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboard.DenialModal}
    >
      <Modal.Header>Reason For {dashboard.ApproveDenialHeader}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.TextArea
              label="Comments"
              placeholder="Please Specify a reason"
              maxLength="500"
              name="comments"
              value={comments}
              onChange={handleChange}
            />
          </Form>
          <Divider horizontal>Or</Divider>
          <Form>
            <Form.Field
              id="Type"
              options={
                dashboard.ApproveDenialHeader === 'Deny'
                  ? DenyOptions
                  : dashboard.ApproveDenialHeader === 'Move' ||
                      dashboard.ApproveDenialHeader === 'Pack' ||
                      dashboard.ApproveDenialHeader === 'Movement Complete'
                    ? moveOptions
                    : dashboard.ApproveDenialHeader === 'Verify'
                      ? VerifyOptions
                      : dashboard.ApproveDenialHeader === 'Approve'
                        ? ApproveOptions1
                        : ApproveOptions
              }
              control={Select}
              label="Reasons"
              name="comments"
              placeholder=""
              clearable
              value={commentDropValue}
              onChange={(_e: any, data: any) => {
                setCommentDropValue(data.value);
                setComments('');
              }}
            />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => DenialModalOpen(false, '', false, '')}
        >
          Cancel
        </Button>
        <Button
          content="Save"
          labelPosition="right"
          icon="checkmark"
          onClick={saveFunction}
          positive
          disabled={
            (comments.length || commentDropValue.length) < 1 ? true : false
          }
        />
      </Modal.Actions>
    </Modal>
  );
}
export default observer(ApproveModalOutward);
